import React from 'react';
import { Navbar } from '../../home/components/Navbar';
import { Footer } from '../../home/components/Footer';

export default function SummerlinPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-map-pin-line text-[#FF6B35] text-xl"></i>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Service Area</span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6">
              Summerlin Pool Repair &amp; Construction Services
            </h1>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              RW Construction is your premier general contractor serving Summerlin, Nevada. We specialize in pool repair, pool plaster repair, synthetic grass installation, paver installation, concrete work, landscaping, HVAC services, roofing, and complete home remodeling for Summerlin's luxury residential and commercial properties.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-calendar-line text-xl"></i>
                Schedule Appointment
              </button>
            </div>
          </div>
        </div>
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <a
            href="tel:7027606213"
            className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-2xl"></i>
            Call 702-760-6213
          </a>
        </div>
      </section>

      {/* Services in Summerlin */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#2C2C2C] mb-12 text-center">
            Our Summerlin Construction Services
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-water-flash-line', title: 'Pool Repair Summerlin', desc: 'Premium pool repair and pool plaster repair services for Summerlin luxury homes' },
              { icon: 'ri-plant-line', title: 'Synthetic Grass Summerlin', desc: 'High-end synthetic grass installation for beautiful Summerlin landscapes' },
              { icon: 'ri-road-map-line', title: 'Paver Installation Summerlin', desc: 'Custom paver installation for Summerlin driveways, patios, and outdoor living spaces' },
              { icon: 'ri-hammer-line', title: 'Concrete Work Summerlin', desc: 'Quality concrete services for Summerlin residential and commercial properties' },
              { icon: 'ri-home-gear-line', title: 'HVAC Services Summerlin', desc: 'Complete HVAC installation and repair for Summerlin properties' },
              { icon: 'ri-building-line', title: 'Roofing Summerlin', desc: 'Professional roofing services for Summerlin homes and commercial buildings' },
            ].map((service, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#FF6B35] rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us for Summerlin */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-[#2C2C2C] mb-6">
                Why Summerlin Homeowners Choose RW Construction
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                As a trusted general contractor serving Summerlin, Nevada, we understand the high standards of Summerlin properties. From The Ridges to Red Rock Country Club, we deliver exceptional pool repair, synthetic grass installation, paver installation, and complete construction services throughout Summerlin.
              </p>
              <div className="space-y-4">
                {[
                  'Licensed &amp; Insured Summerlin Contractor',
                  '20+ Years Serving Summerlin Area',
                  'Expert Pool Repair &amp; Plaster Services',
                  'Free Estimates for Summerlin Projects',
                  'Quality Workmanship Guaranteed',
                  'Luxury Residential &amp; Commercial Services',
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/159edd657dc2f92e5673d6e497fb7f8e.jpg"
                alt="Summerlin Pool Repair and Construction Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Summerlin Neighborhoods */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#2C2C2C] mb-6 text-center">
            Summerlin Neighborhoods We Serve
          </h2>
          <p className="text-gray-600 text-base text-center max-w-3xl mx-auto mb-12">
            We proudly serve all Summerlin neighborhoods including The Ridges, Red Rock Country Club, The Trails, and more.
          </p>
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              'The Ridges',
              'Red Rock Country Club',
              'The Trails',
              'The Hills',
              'The Crossing',
              'The Paseos',
              'The Vistas',
              'The Mesa',
              'Stonebridge',
              'Sun City Summerlin',
              'Tournament Hills',
              'The Pueblo',
            ].map((neighborhood, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-lg px-4 py-3 text-center">
                <span className="text-gray-700 font-medium text-sm">{neighborhood}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-red-500">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Start Your Summerlin Project?
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Contact RW Construction today for a free estimate on your pool repair, synthetic grass, paver installation, or any construction project in Summerlin.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line text-xl"></i>
              Schedule Appointment
            </button>
            <a
              href="tel:7027606213"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-760-6213 Today
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
